<template>
    <v-menu
        v-model="editing"
        transition="scale-transition"
        :close-on-content-click="false"
        :nudge-width="100"
        :disabled="!allowEditing"
    >
        <template v-slot:activator="{ on }">
            <v-toolbar dense flat color="transparent" class="pa-0">
                <a :class="classTitle" v-on="on" v-text="label"></a>
                <v-spacer />
                <v-icon v-if="isLink" small @click="goToIssue">mdi-open-in-new</v-icon>
            </v-toolbar>
        </template>
        <v-card>
            <v-card-text>
                <v-text-field
                    :label="$t('issues.attributes.supportOutput')"
                    v-if="editing"
                    v-model="editingValue"
                    single-line
                ></v-text-field>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="editing = false" v-text="$t('buttons.cancel')" />
                <v-btn color="success" text @click="changeAttribute" v-text="$t('buttons.save')" />
            </v-card-actions>
        </v-card>
    </v-menu>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'issue-support-output',
    data: () => ({
        editing: false,
        editingValue: undefined,
    }),
    props: {
        issue: {},
        allowEditing: {
            default: true,
        },
        onlyEdit: {
            default: false,
        },
    },
    watch: {
        editing: function (e) {
            if (e) {
                this.editingValue = this.issue.supportOutput;
            }
        },
    },
    computed: {
        ...mapGetters(['project']),
        classTitle() {
            const clazz = 'blue-grey--text ';
            return this.$vuetify.theme.dark ? clazz + 'text--lighten-4' : clazz + 'text--darken-2';
        },
        isLink() {
            return this.issue.supportOutput.startsWith('http');
        },
        label() {
            if (this.isLink) {
                return this.$t('issues.actions.supportOutputLink');
            } else {
                return this.issue.supportOutput ? this.issue.supportOutput : '-';
            }
        },
    },
    methods: {
        ...mapActions(['updateIssue']),
        async changeAttribute(value) {
            if (this.onlyEdit) {
                this.$emit('update-attribute', { name: 'supportOutput', value: this.editingValue });
                this.editing = false;
            } else {
                await this.updateIssue({
                    id: this.issue.id,
                    supportOutput: this.editingValue,
                });

                this.editing = false;
                this.$emit('change-attribute-value');
            }
        },
        goToIssue() {
            window.open(this.issue.supportOutput, '_blank');
        },
    },
};
</script>
<style scoped>
.v-toolbar >>> .v-toolbar__content {
    padding: 0px !important;
}
</style>
